import React, {Component} from 'react';
import {Redirect} from 'react-router-dom';
import {PostData} from '../../services/PostData';
import {GetData} from '../../services/GetData';
import {
  Row,
  Col,
  Button,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownIti,
  Card,
  CardHeader,
  CardFooter,
  CardBody,
  Collapse,
  Form,
  FormGroup,
  FormText,
  Label,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Table,
  Modal, ModalHeader, ModalBody, ModalFooter,
  Pagination, PaginationIti, PaginationLink
} from 'reactstrap';
import FileBase64 from 'react-file-base64';
import $ from 'jquery';
import Loader from '../../Loader';
import StudentPage from '../../views/StudentPage/';
const GLOBAL = require('../../Globals');

class MobileUpload extends Component {
	
	/** set property value **/
	constructor(props){
		super(props);
		this.state = {
			_message : '',
			modal: false,
			alertClass :'',
			loading: false,
			files : [],
			currentPage: 1,
			todosPerPage: 3
		}
		this.togglePrimary = this.togglePrimary.bind(this);
		this.onChange = this.onChange.bind(this);
		this.showmodal = this.showmodal.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
	}
	
	//base64 photo
	getFiles(files){
		this.setState({ files: files });
		console.log(this.state);
	}
	
	showmodal(){
		
		this.setState({
					modal: !this.state.modal
		});
		
	}
	
	onChange(e){
		this.setState({[e.target.name]:e.target.value});
		console.log(this.state);
	}
	
	togglePrimary(e){
		this.setState({
		  modal: !this.state.modal
		});
	}
	
	onSubmit(e){
		e.preventDefault();
		$("#showLoader").show();	
		PostData('student/mobileupdate',this.state).then((result) => {
			$("#showLoader").hide();	
			let responseJson = result;
			// console.log(responseJson);
			if(responseJson.status == '1' ){
				sessionStorage.setIti('userData',JSON.stringify(responseJson));
				// console.log(JSON.stringify(responseJson));
				this.setState({
					_message: responseJson.msg+' Mobile Numbers Updated Successfully!..',
					alertClass:'alert alert-success',
					loading:false
				});
				this.setState({files: []});
				document.getElientById("stmobform").reset();
			}
			else{
		
				this.setState({
					_message:'Error',
					alertClass:'alert alert-danger'
				});
			}
		});
	}
	
	
	

	
  render() {
	  
	 
	
    return (
		<div>
		  <StudentPage />
			<div className="animated fadeIn">
				<div className={this.state.alertClass}>
					{this.state._message}
				</div>
				<form action="" method="post" role="form" id="stmobform" encType="multipart/form-data" onSubmit={this.onSubmit} >
				<Row>
				  <Col md="12">
					<Card>
						<CardHeader>
							<strong>Student Mobile Upload</strong>
							<Button size="sm" className="btn-right" color="danger" onClick={this.showmodal}><i className="fa fa-info"></i> Instructions</Button>
						</CardHeader>
						<CardBody>
							<Row>
							  <Col md="4">
								<FormGroup>
									<FileBase64 onDone={ this.getFiles.bind(this) } required />
								</FormGroup>
							</Col>
							<Modal isOpen={this.state.modal} toggle={this.togglePrimary} className={'modal-primary ' +this.props.className}>
						  <ModalHeader toggle={this.togglePrimary}>Instructions</ModalHeader>
						  <ModalBody>
							<Row>
							  <Col md="12">
								<Card className="border-info">
									<CardBody className="">
										<div className="alert alert-success">
										<p><i className="fa fa-info-circle"></i>&nbsp; Download the excel file format from below link and copy the below values in corresponding columns while filling excel sheet. </p> <br />
										<p><i className="fa fa-info-circle"></i>&nbsp; Upload Only .CSV File (Remove All empty Rows and Columns)</p><br />
										<a href={GLOBAL.BASE_URL+'public/mobilesample/samplexl.xlsx'} className="alert-link" > <p className="text-info"> <i className="fa fa-file-excel-o"></i>&nbsp; Sample excel format </p> </a> <br />
										<a href={GLOBAL.BASE_URL+'public/mobilesample/sample_csv.csv'} className="alert-link" > <p className="text-info"> <i className="fa fa-file-excel-o"></i>&nbsp; Sample CSV format </p> </a>
										</div>
									</CardBody>
								</Card>
							  </Col>
							 
							</Row>
						  </ModalBody>
						 
					  </Modal>
							</Row>
						</CardBody>
					<CardFooter>
					  <Button type="submit" size="sm" color="primary" className="btn-right" ><i className="fa fa-dot-circle-o"></i> Update</Button>
					</CardFooter>
					</Card>
				  </Col>
				</Row>
			  </form>
			</div>
		</div>
	)
  }
}

export default MobileUpload;


// WEBPACK FOOTER //
// ./src/student/MobileUpload/MobileUpload.js